import {atom} from 'jotai'

import {Package} from '../domain'

const initialPackage: Package = {
  id: '',
  status: 1,
  isEditable: true,
  activationDate: '',
  additionalBenefits: null,
  adults: false,
  beginners: false,
  cancellationFee: 1.0,
  termsAndConditions: '',
  cancellationFeeBase: 0.0,
  cancellationPolicy: null,
  children: false,
  duration: null,
  customerGroupID: null,
  description: '',
  discount: 0.0,
  discountFixedAmount: 0.0,
  earlyBirdDiscount: 0.0,
  eligibility: null,
  eligibleforPoint: 0,
  featuresAndBenefits: null,
  imagesData: [],
  menuDisplayOrder: 0,
  merchantID: null,
  ofCustomers: 999999,
  packageCategoryID: '',
  packageGroupID: null,
  packageName: '',
  packageTypeID: '',
  priceWithoutTax: 0.0,
  recurring: 0,
  priceWithoutTaxBase: 0.0,
  professionals: false,
  price: null,
  count: null,
  purchaseType: 1,
  ribbon: 0,
  salesPrice: 0.0,
  salesPriceBase: 0.0,
  skillLevel: null,
  subscriptionOptions: 2,
  taxRate: 5,
  termsConditions: null,
  unitPrice: 0.0,
  unitPriceBase: 0.0,
  validity: 0,
  visibleOnApp: 1,
  visibleOnCustomerPortal: 1,
  infoContentData: [],
  items: [],
}

export const detailAtom = atom<Package>(initialPackage)

export const categoriesAtom = atom<
  {
    id: string
    name: string
  }[]
>([])

export const familysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])

export const visibilitysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])
